import React from 'react';
import { useNavigate } from 'react-router-dom'; // Yönlendirme için ekledik
import { 
  Baby, Droplets, Video, ShieldCheck, Activity, Wind, 
  Stethoscope, Thermometer, Scissors, FlaskConical, 
  Heart, AlertCircle, Syringe, Biohazard, UserRound,
  Waves, Anchor, Flame, Search, Zap 
} from 'lucide-react';
import './Specializations.css';

const Specializations = () => {
  const navigate = useNavigate();

  const treatments = [
    { id: 1, title: "Kasık Fıtığı", icon: <Baby size={35} />, color: "#4FBDBA", bg: "#e0f2f1" },
    { id: 2, title: "Hidrosel (Su Fıtığı)", icon: <Droplets size={35} />, color: "#FFB347", bg: "#fff3e0" },
    { id: 3, title: "İnmemiş Testis", icon: <Video size={35} />, color: "#7ED957", bg: "#f1f8e9" },
    { id: 4, title: "Sünnet ve Yenidoğan Sünneti", icon: <ShieldCheck size={35} />, color: "#6C5CE7", bg: "#f3e5f5" },
    { id: 5, title: "Testis ve Over Torsiyonu", icon: <Activity size={35} />, color: "#F06292", bg: "#fce4ec" },
    { id: 6, title: "Hipospadias (Peygamber Sünneti)", icon: <Stethoscope size={35} />, color: "#4FC3F7", bg: "#e1f5fe" },
    { id: 7, title: "İdrar Yolu Enfeksiyonları", icon: <Thermometer size={35} />, color: "#FF7043", bg: "#fbe9e7" },
    { id: 8, title: "External Üretral Meada Darlık", icon: <Scissors size={35} />, color: "#9575CD", bg: "#ede7f6" },
    { id: 9, title: "İnvajinasyon (Bağırsak Düğüm)", icon: <Activity size={35} />, color: "#4DB6AC", bg: "#e0f2f1" },
    { id: 10, title: "Labial Füzyon", icon: <UserRound size={35} />, color: "#BA68C8", bg: "#f3e5f5" },
    { id: 11, title: "Anal Darlık", icon: <Zap size={35} />, color: "#FF8A65", bg: "#fbe9e7" },
    { id: 12, title: "Dilaltı Bağı Cerrahisi", icon: <Scissors size={35} />, color: "#AED581", bg: "#f1f8e9" },
    { id: 13, title: "Karın Ağrısı ve Kusma", icon: <AlertCircle size={35} />, color: "#E57373", bg: "#ffebee" },
    { id: 14, title: "Gastro-Ozefagial Reflü", icon: <FlaskConical size={35} />, color: "#AED581", bg: "#f1f8e9" },
    { id: 15, title: "Karaciğer & Safra Kesesi", icon: <Heart size={35} />, color: "#E57373", bg: "#ffebee" },
    { id: 16, title: "Kabızlık & Kaka Kaçırma", icon: <Waves size={35} />, color: "#4DD0E1", bg: "#e0f7fa" },
    { id: 17, title: "İdrar Kaçırma Problemleri", icon: <Anchor size={35} />, color: "#7986CB", bg: "#e8eaf6" },
    { id: 18, title: "Meme Hastalıkları", icon: <ShieldCheck size={35} />, color: "#F06292", bg: "#fce4ec" },
    { id: 19, title: "Boyun Bölgesi Hastalıkları", icon: <Search size={35} />, color: "#4DB6AC", bg: "#e0f2f1" },
    { id: 20, title: "Göbekten Akıntı & Kanama", icon: <Flame size={35} />, color: "#FFD54F", bg: "#fff9c4" },
    { id: 21, title: "Rektal Kanama", icon: <Droplets size={35} />, color: "#E57373", bg: "#ffebee" },
    { id: 22, title: "Kıl Dönmesi (Pilonidal Sinüs)", icon: <Biohazard size={35} />, color: "#A1887F", bg: "#efebe9" },
    { id: 23, title: "Over (Yumurtalık) Kistleri", icon: <Wind size={35} />, color: "#4FC3F7", bg: "#e1f5fe" }
  ];

  // Sonsuz döngü animasyonu için listeyi katlıyoruz
  const doubleTreatments = [...treatments, ...treatments];

  return (
    <section className="spec-playful-section">
      <div className="spec-bubbles">
        <div className="s-bubble ball-1"></div>
        <div className="s-bubble ball-2"></div>
        <div className="s-bubble ball-3"></div>
      </div>

      <div className="spec-inner">
        <div className="spec-header-playful">
          <h2 className="spec-main-title">Uzmanlık <span>Alanlarımız</span></h2>
          <p>Minik kahramanlar için 30 yılı aşkın tecrübeyle akademik ve modern cerrahi çözümler.</p>
        </div>

        <div className="spec-slider-container">
          <div className="spec-track">
            {doubleTreatments.map((t, index) => (
              <div 
                key={index} 
                className="spec-play-card" 
                onClick={() => navigate('/uzmanliklar')} // Tıklanınca yönlendir
                style={{ 
                  "--card-accent": t.color, 
                  "--card-bg": t.bg,
                  cursor: 'pointer' 
                }}
              >
                <div className="icon-circle-floating">
                  {t.icon}
                </div>
                <div className="spec-card-body">
                  <h3>{t.title}</h3>
                  <p>Detaylı bilgi için tıklayın.</p>
                </div>
                <div className="card-decoration"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specializations;